import * as ScholarshipPaymentStoreActions from './scholarship-payment.actions';
import * as ScholarshipPaymentStoreSelectors from './scholarship-payment.selectors';
import * as ScholarshipPaymentStoreReducer from './scholarship-payment.reducer';

export { ScholarshipPaymentStoreActions, ScholarshipPaymentStoreSelectors, ScholarshipPaymentStoreReducer };
